import { render } from "./EnvoiExpress.vue?vue&type=template&id=49e10e6c&scoped=true&ts=true"
import script from "./EnvoiExpress.vue?vue&type=script&lang=ts"
export * from "./EnvoiExpress.vue?vue&type=script&lang=ts"

import "./EnvoiExpress.vue?vue&type=style&index=0&id=49e10e6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e10e6c"]])

export default __exports__